import React from 'react';
import { FormattedMessage } from 'react-intl';
import { useSelector } from 'react-redux';

import { getAllCars } from '@/modules/car/store/selectors';

import { TwoLineCell } from '../TwoLineCell';

interface ICarCellProps {
  carId?: string;
}

const CarCell = React.memo<ICarCellProps>(({ carId }) => {
  const cars = useSelector(getAllCars);
  const car = cars.find(c => c.id === carId);

  return car ? (
    <TwoLineCell line1={[car.make, car.model].join(' ')} line2={car.licensePlate} />
  ) : (
    <FormattedMessage defaultMessage="No" id="4ntpuE" description="No assigned car for driver" />
  );
});

export { CarCell };
